module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("8yhs3"))).then(() => parcelRequire('dJXJK'));